import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Divider,
} from "@nextui-org/react";

import { useParams } from "react-router-dom";
import { MdDelete } from "react-icons/md";

import Button from "@/components/Button";
import Modal from "@/components/Modal";
import ConfirmDelete from "@/components/ConfirmDelete";

import { useDeleteMaterial } from "../hooks/useDeleteMaterial";
import { useMaterialFile } from "../../../web/lecture/hooks/useMaterialFile";
import { Skeleton, Stack } from "@mui/material";
import fileDownload from "js-file-download";
import { FaDownload } from "react-icons/fa6";
import usePermission from "./../../../../hooks/usePermission";
import UpdateMaterial from "./UpdateMaterial";

function MaterialCard({ material }) {
    const { can } = usePermission();

    const { courseId, lectureId } = useParams();

    const { name, brief, file } = material.attributes;
    const { id } = material;

    const fileExtention = file?.split(".")[1];

    const { deleteMaterial, isDeleting } = useDeleteMaterial();

    const { isPending, materialFile } = useMaterialFile({
        courseId,
        lectureId,
        materialId: id,
    });

    if (isPending)
        return (
            <div className="flex flex-wrap items-center justify-between gap-4">
                <Stack spacing={1} className="w-full">
                    <Skeleton
                        variant="rounded"
                        height={275}
                        className="w-[298px]"
                    />
                </Stack>
                <Stack spacing={1} className="w-fit">
                    <Skeleton
                        variant="rounded"
                        height={275}
                        className="w-[298px]"
                    />
                </Stack>
            </div>
        );

    return (
        <>
            <Card className="w-[298px] h-[275px] pt-3">
                <CardHeader className="flex items-center justify-between">
                    <div className="flex gap-3">
                        {/* <BiSolidVideos className="text-4xl text-primary-color-primary" /> */}
                        <img
                            src={
                                fileExtention === "pdf"
                                    ? "/images/courses/pdfIcon.webp"
                                    : "/images/courses/imageIcon.webp"
                            }
                            loading="lazy"
                            alt="file type Icon"
                            decoding="async"
                        />
                        <div className="flex flex-col">
                            <p className="text-md">{name}</p>
                            <p className="text-small text-default-500">
                                {fileExtention}
                            </p>
                        </div>
                    </div>

                    {can("delete:course:lecture:materials") && (
                        <Modal>
                            {/* Modal For Delete Video */}
                            <Modal.Open opens={`delete-${id}`}>
                                <button>
                                    <MdDelete className="text-3xl transition-all duration-300 text-red-color-primary hover:text-red-900" />
                                </button>
                            </Modal.Open>
                            <Modal.Window name={`delete-${id}`}>
                                <ConfirmDelete
                                    resourceName={name}
                                    disabled={isDeleting}
                                    onConfirm={() =>
                                        deleteMaterial({
                                            courseId,
                                            lectureId,
                                            materialId: id,
                                        })
                                    }
                                />
                            </Modal.Window>
                        </Modal>
                    )}
                </CardHeader>

                <Divider />

                <CardBody className="text-right">
                    <p className="pt-2">
                        الوصف :
                        <span className="text-gray-color-primary">{brief}</span>
                    </p>
                </CardBody>

                <CardFooter className="justify-between">
                    <Modal>
                        {/* Modal For Update Video */}
                        {can("update:course:lecture:materials") && (
                            <>
                                <Modal.Open opens={`update-${id}`}>
                                    <Button type="primary">تعديل</Button>
                                </Modal.Open>

                                <Modal.Window name={`update-${id}`}>
                                    <UpdateMaterial oldMaterial={material} />
                                </Modal.Window>
                            </>
                        )}
                    </Modal>
                    <Button
                        type="customized"
                        className="p-2.5 rounded-lg bg-mint-green-color-primary"
                        onClick={() => {
                            fileDownload(
                                materialFile,
                                `${name}.${fileExtention}`
                            );
                        }}
                        name="download material item button"
                    >
                        <FaDownload className="text-lg text-white" />
                    </Button>
                </CardFooter>
            </Card>
        </>
    );
}

export default MaterialCard;
